import { EntityModel } from '@/interfaces'
import {
  ALL_AGE_GROUPS_QUERY,
  CREATE_AGE_GROUP_MUTATION,
  DELETE_AGE_GROUP_MUTATION,
  FORCE_DELETE_AGE_GROUP_MUTATION,
  SINGLE_AGE_GROUP_QUERY,
  UPDATE_AGE_GROUP_MUTATION,
} from './graphql'

const travelPricingAgeGroupModel: EntityModel = {
  name: 'ageGroup',
  namePlural: 'ageGroups',
  uniqueName: 'travelPricingAgeGroup',
  uniqueNamePlural: 'travelPricingAgeGroups',
  path: 'travel/pricing/age_group',
  baseUrl: '/travel/pricing/age_groups',
  translationPrefix: 'entities:travelPricingAgeGroup.',
  getDisplayName: (values: any) => {
    return `${values.name} (${values.minAge}-${values.maxAge})`
  },
  gql: {
    getAll: ALL_AGE_GROUPS_QUERY,
    getSingle: SINGLE_AGE_GROUP_QUERY,
    create: CREATE_AGE_GROUP_MUTATION,
    update: UPDATE_AGE_GROUP_MUTATION,
    delete: DELETE_AGE_GROUP_MUTATION,
    forceDelete: FORCE_DELETE_AGE_GROUP_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:travelPricingAgeGroup.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    type: {
      name: 'type',
      label: 'entities:travelPricingAgeGroup.attributes.type.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:travelPricingAgeGroup.attributes.type.selectOptions.ADULT.label',
          value: 'ADULT',
        },
        {
          label: 'entities:travelPricingAgeGroup.attributes.type.selectOptions.MINOR.label',
          value: 'MINOR',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    icon: {
      name: 'icon',
      label: 'entities:travelPricingAgeGroup.attributes.icon.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    minAge: {
      name: 'minAge',
      label: 'entities:travelPricingAgeGroup.attributes.minAge.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    maxAge: {
      name: 'maxAge',
      label: 'entities:travelPricingAgeGroup.attributes.maxAge.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelPricingAgeGroupModel
